module.exports = __webpack_public_path__ + "img/9788994197395.bcfe995d.jpg";